export default "__VITE_ASSET__a7719047__"